import React, { useState } from 'react';
import GeoTargetingPopup from '../popupsteps/GeoTargetingPopup'; // Step 2
import QualityStep from '../steps/QualityStep'; // Step 4
import BidStep from '../steps/BidStep'; // Step 5
import CreativeStep from '../steps/CreativeStep'; // Step 6
import BudgetStepPopup from '../popupsteps/Budgetpopup'; // Step 7
import LanguageTargetingPopup from '../popupsteps/LanguageTargetingPopup'; // Optional Advanced Settings
import './AdTypeComponent.css';
import TargetingStepProps from "../popupsteps/TargetingPopup";
import OsbroswerPopup from "../popupsteps/osbroswerPopup";
import ConnectionTypePopup from "../popupsteps/ConnectionTypePopupProps";
import DaypartingPopup from '../popupsteps/DaypartingPopup ';
import SubidBlacklistingPopup from "../popupsteps/SubidBlaclistingPopuphandle";
import SubidWhitelistingPopupProps from "../popupsteps/SubWhitelistingPopup";
import BidOverridingPopup from "../popupsteps/BidoverridingPopup"; 
import BidAutomationPopup from "../popupsteps/BidAutomationPopup";
import BidAutomationLogPopup from "../popupsteps/BidAutomationlogPopup ";
import PincodeDataPopup from "../popupsteps/PincodedataPopup";


// Define the initial form data structure
const initialFormData = {
  adFormat: '',
  campaignName: '',
  bid: '',
  geo: '',
  bidRequests: '',
  videoImp: '',
  visits: '',
  winRate: '',
  cost: '',
  dailyCap: '',
  name: '',
  code: '',
  adName: '',
  title: '',
  description1: '',
  description2: '',
  displayURL: '',
  destinationURL: '',
  trafficSourceType: '',
  frequencyFilter: '',
  impressions: '',
  clicks: '',
  conversions: '',
  budget: '',
  targetingOptions: '',
  qualityScore: '',
  noDailyLimit: '',
  disabledSources: '', // Add this line
  bidOverrideList: '', // Add this field
  targetConversionRate: '', // Add required properties
  targetCostPerConversion: '',
  optimizationTimeframe: '',
  minimumClicks: '',
  setFactor: '',
  maxOverrideBid: '',
  minOverrideBid: '',
  pinCode: '', // Add this
  date: '',    // Add this
};

// Define steps for the form
const steps = [
  { label: 'Daily Ad Budget', active: true },
  { label: 'Geo Targeting', active: false },
  { label: 'Langugae Targeting', active: false },
  { label: 'Targeting', active: false },
  { label: 'OS Browser', active: false },
  { label: 'Connection Type', active: false },
  { label: 'Quality Score', active: false },
  { label: 'Day Parting', active: false },
  { label: 'Subid Blacklisting', active: false },
  { label: 'Subid Whitelisting', active: false },
  { label: 'Bid Override', active: false },
  { label: 'Bid Automation', active: false },
  { label: 'Bid AutomationLog', active: false },
  { label: 'Pin Code Data', active: false },
];

interface StepProps {
  recordId: number; // ID of the record to edit
  handleClose: () => void; // Close the popup
  onUpdate: () => void; // Callback to refresh the data after update
}

const PopupMultiform: React.FC<StepProps> = (
  {
    recordId,
    handleClose,
    onUpdate,
  }
) => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState(initialFormData);

  // Handle form field changes
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  

  // Handle step changes
  const handleStepChange = (stepIndex: number) => {
    setStep(stepIndex);
  };

 

  

  return (
    <div style={{ display: 'flex', padding: '0px', margin: '-20px' }}>
      {/* Sidebar Navigation */}
      <div
        className="sidebar-navigation"
        style={{
          width: '200px',
          height: '100vh',
          backgroundColor: '#f5f5f5',
          borderRight: '1px solid #ddd',
          padding: '20px',
        }}
      >
        {steps.map((stepInfo, index) => (
          <div
            key={index}
            className={`step-item ${step === index + 1 ? 'active' : ''}`}
            onClick={() => handleStepChange(index + 1)}
            style={{
              padding: '5px 5px',
              marginBottom: '5px',
              backgroundColor: step === index + 1 ? '#dfefff' : 'transparent',
              cursor: 'pointer',
              borderRadius: '4px',
              color: step === index + 1 ? '#0056b3' : '#333',
              fontWeight: step === index + 1 ? 'bold' : 'normal',
              fontSize: '14px',
            }}
          >
            {stepInfo.label}
            
          </div>
        ))}
      </div>

      {/* Form Steps */}
      <div style={{ flex: 1, padding: '20px' }}>
        {step === 1 && <BudgetStepPopup recordId={recordId}  handleClose={() => handleClose} onUpdate={onUpdate} />}
        {step === 2 && <GeoTargetingPopup handleInputChange={handleInputChange} formData={formData}  recordId={recordId} handleClose={() => handleClose}  onUpdate={onUpdate}/>}
        {step === 3 && <LanguageTargetingPopup  handleInputChange={handleInputChange} formData={formData} recordId={recordId}  handleClose={() => handleClose} onUpdate={onUpdate}/>}
        {step === 4 && <TargetingStepProps recordId={recordId}  handleClose={() => handleClose} onUpdate={onUpdate} />}
        {step === 5 && <OsbroswerPopup recordId={recordId.toString()}  handleClose={() => handleClose} onUpdate={onUpdate} />}
        {step === 6 && <ConnectionTypePopup recordId={recordId.toString()} handleClose={handleClose} onUpdate={onUpdate} />}
        {step === 7 && <QualityStep handleInputChange={handleInputChange} formData={formData} />}
        
        {step === 8 && <DaypartingPopup recordId={recordId.toString()} handleClose={handleClose} onUpdate={onUpdate} />}
        {step === 9 && <SubidBlacklistingPopup recordId={recordId.toString()} handleClose={handleClose} onUpdate={onUpdate} handleInputChange={handleInputChange} formData={formData}/>}
        {step === 10 && <SubidWhitelistingPopupProps recordId={recordId.toString()} handleClose={handleClose} onUpdate={onUpdate} handleInputChange={handleInputChange} formData={formData}/>}
        {step === 11 && <BidOverridingPopup recordId={recordId.toString()} handleClose={handleClose} onUpdate={onUpdate} handleInputChange={handleInputChange} formData={formData}/>}
        {step === 12 && <BidAutomationPopup recordId={recordId.toString()} handleClose={handleClose} onUpdate={onUpdate} handleInputChange={handleInputChange} formData={formData}/>}

        {step === 13 && <BidAutomationLogPopup recordId={recordId.toString()} handleClose={handleClose} onUpdate={onUpdate} />}
        {step === 14 && <PincodeDataPopup recordId={recordId.toString()} handleClose={handleClose} onUpdate={onUpdate} handleInputChange={handleInputChange} formData={formData} />}

      </div>
    </div>
  );
};

export default PopupMultiform;
